export default __webpack_public_path__ + "static/media/granville26.43735991.jpg";